import React from 'react'
import { useContext, useState } from 'react'
import AppContext from '../context/appContext'
import { useRef } from 'react'
const Withdraw = () => {
    const appContext = useContext(AppContext)

    const { authToken, createAccount, setAuthToken, getUser, userData, withdrawlAmount,withdrawRef } = appContext
    const [withdrawAmount, setWithdrawAmount] = useState(null)
    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(date.getUTCFullYear()).slice(-2);

        return `${day}/${month}/${year}`;
    }
    console.log(userData);

    if(withdrawAmount<0){
        setWithdrawAmount(0)
    }

    const withdrawButtonRef = useRef(null)
    return (
        <div>
            <div className="px-md-5">
                <h1 className="text-light">Withdraw Funds</h1>
            </div>
            <button ref={withdrawButtonRef} type="button" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
                Launch demo modal
            </button>

            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" data-bs-theme="dark" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5 text-light" id="exampleModalLabel">Transaction Confirmation</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                         
                           <p className="text-light "><b>To</b>: {userData.walletAddress}</p>
                           <p className="text-light"><b>Amount</b>: ${withdrawAmount}</p>
                           <p className="text-light "><b>Transaction Fee:</b> 0% by VTC</p>
                           <p className="text-muted">Please note that the withdrawl request takes 6-7 workings days to be processed</p>
                        </div>
                        <div class="modal-footer">
                            <button ref={withdrawRef} type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button onClick={() => withdrawlAmount(withdrawAmount)} type="button" class="btn btn-light">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center  w-100 pt-5">
                <div className="d-flex flex-column input-group-custom px-md-5">
                    {/* <input style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type="text" class="my-2 form-control" id="exampleFormControlInput1" placeholder="User Wallet Address" /> */}
                    <input value={withdrawAmount} onChange={(e) => setWithdrawAmount(e.target.value)} style={{ backgroundColor: "#23153c", color: "white", borderColor: "white" }} type="number" class="my-2 form-control" id="exampleFormControlInput1" placeholder="Amount" />
                    <span className="text-light">{`Current Balance: $${userData.currentUserBalance}`}</span>
                    <button onClick={() => withdrawButtonRef.current.click()} disabled={withdrawAmount > userData.currentUserBalance || withdrawAmount<10} className="btn btn-light w-100 my-2 ">Withdraw</button>
                    <p className="text-light py-2">Easily withdraw your bonus and profits with zero transaction fees, ensuring a hassle-free experience.</p>
                </div>
            </div>
            <div className="px-md-5">
                <h1 className="text-light pb-3">Transfer Statistics</h1>
                <div className="row">
                    <div className="col-sm-6 col-lg-6 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-1 h1 text-light' style={{ fontWeight: "bold" }}>{`${userData.withdraws.length}`}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Withdraws</h2>
                                <p class="card-text text-light">Total number of withdraws pending and completed</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-6 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-1 h1 text-light' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.withdrawlAmount * 1000) / 1000}`}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Withdraws Amount</h2>
                                <p class="card-text text-light">Total amount of withdraws pending and completed</p>

                            </div>
                        </div>
                    </div>
                </div>
                <h1 className="text-light my-4">Withdraw History</h1>
                <div className="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                              
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Amount</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Date</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userData.withdraws.map((e) => {
                                return <tr>
                                  
                                    <td style={{ backgroundColor: "#23153c", color: "white", fontWeight: "bold" }}>${e.amount}</td>
                                    <td style={{ backgroundColor: "#23153c", color: "white" }}>{formatDate(e.date)}</td>
                                    <td style={{ backgroundColor: "#23153c", color: "white" }}>{e.status}</td>
                                </tr>
                            })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Withdraw